import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const MenuHeader = ({ title, onClose }) => {
  return (
    <Box>
      {/* Close Button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <IconButton
          onClick={onClose}
          size="large"
          sx={{ color: "#111", bgcolor: "#ffffff", borderRadius: "50px" }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Title */}
      <Typography
        variant="h3"
        sx={{
          fontWeight: 900,
          fontSize: "36px",
          textTransform: "uppercase",
          marginBottom: "16px",
          fontFamily: "Zen Maru Gothic",
          color: "#111",
          lineHeight: "1.1",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default MenuHeader;
